/*
 * Public API Surface of ngx-window-token
 */

export * from './lib/window';
